'use strict';
let help = {}; // namespace

// switch off name
let COOKIE_SWITCH_OFF = 'help';

/**
 * Initialize the help functionality.
 * @param helpGroup     the help group id
 * @param cookieName    the cookie name
 * @param labels        the additional labels, object {close : "<text>", check : "<text>", span : "<text>", btn : "<text>"}
 * @param helpTexts     the help texts, i.e. an array of objects [{key : "<data-hid value>", msg : "<text of help label>", 
 *                      pos : "top" | "topleft" |"topright" | "bottom" |"bottomleft" | "bottomright" | "left" | "right",
 *                     lng : <arrow length as float factor>, offx : <x-offset to dom element as int> , offy : <y-offset to dom element as int>}]
 */
help.init = function (helpGroup, cookieName, labels, helpTexts) {
    if (help.shouldBeShown(helpGroup, cookieName)) {
        $('body').addClass('show-help');
        let data = {
            helpGroup: helpGroup,
            cookie: cookieName,
            lbl: labels,
            texts: helpTexts
        };
        help.addHelpLayer({data: data});

        $(window).on('resize', data, help.addHelpLayer);
    }
};

/**
 * Destroys the help functionality.
 */
help.destroy = function () {
    $(window).off('resize', help.addHelpLayer);
    help.removeHelpLayer();
    $('body').removeClass('show-help');
};

/**
 * Add the help layer and the svg node.
 * @param e      the event
 */
help.addHelpLayer = function (e) {
    help.removeHelpLayer();
    let $helpLayer = $("<div id='help-layer'><div id='help-overlay'></div><button id='help-close' type='button' title='" + e.data.lbl.close + "'><i class='bi-icons bi-x' role='img' aria-label='default'></i></button><div id='help-data'><svg xmlns='http://www.w3.org/2000/svg'><defs><marker id='arrow' orient='auto' markerWidth='7' markerHeight='7' refX='0.1' refY='3'><path d='M0,0 L0,6 L5,3 L0,0' fill='whitesmoke'/></marker></defs></svg></div><div id='help-bar'><div class='container'><div class='row'><div class='col-7'><label for='hide'><input type='checkbox' name='help-hide' id='help-hide'>" + e.data.lbl.check + "</label></div><div id='help-close2' class='col-5'><span>" + e.data.lbl.span + "</span><button type='button'>" + e.data.lbl.btn + "</button></button></div></div></div></div></div>");
    $('body').append($helpLayer);

    $('#help-close').click(function () {
        help.hideHelpDialog(e.data.helpGroup, e.data.cookie);
        help.destroy();
    });

    $('#help-close2').find('button').click(function () {
        help.hideHelpDialog(e.data.helpGroup, e.data.cookie);
        help.destroy();
    });

    $('#help-hide').click(function () {
        help.hideHelp(e.data.cookie);
        help.destroy();
    });

    $.each(e.data.texts, function (i, helpText) {
        let $dom = $('[data-hid="' + helpText.key + '"]');
        if ($dom.length > 0 && $dom.is(":visible")) {
            help.addLabel($dom, helpText.msg, helpText.pos, helpText.lng, helpText.offx, helpText.offy);
        }
    });
};

/**
 * Remove the help layer
 */
help.removeHelpLayer = function () {
    let $helpLayer = $('#help-layer');
    if ($helpLayer) {
        $helpLayer.remove();
    }
};

/**
 * Adds a single help text with line
 * @param $dom      the dom node to add the help text to
 * @param text      the label text
 * @param pos       the position of the help text, valid values are: top, topleft (default), topright, bottom, bottomleft, bottomright, left, right
 * @param length    the length of the line (factor)
 * @param offX      the x-offset to the dom node
 * @param offY      the y-offset to the dom node
 */
help.addLabel = function ($dom, text, pos, length, offX, offY) {
    if (!$dom || $dom.length === 0 || !$dom.is(":visible")) {
        return;
    }

    let $helpData = $('#help-data');
    if (!$helpData) {
        return;
    }

    let $label = $('<div class="help-label" style="left:0;top:0;">' + text + '</div>');
    $helpData.append($label);
    let svgPos = help.calculatePos($dom, $label, pos, length, offX, offY);

    if (svgPos) {
        let ns = "http://www.w3.org/2000/svg";
        let path = document.createElementNS(ns, "path");
        path.setAttribute('marker-end', 'url(#arrow)');
        path.setAttribute('stroke-width', '1.5');
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', 'whitesmoke');
        if (pos === "top" || pos === "bottom" || pos === "left" || pos === "right") {
            path.setAttribute('d', 'M' + svgPos.fromX + ',' + svgPos.fromY + ' L' + svgPos.toX + ',' + svgPos.toY);
        } else {
            path.setAttribute('d', 'M' + svgPos.fromX + ',' + svgPos.fromY + ' C' + svgPos.cpX1 + ',' + svgPos.cpY1 + ' ' + svgPos.cpX2 + ',' + svgPos.cpY2 + ' ' + svgPos.toX + ',' + svgPos.toY);
        }
        $helpData.children('svg').append(path);

        $label.offset(svgPos.labelPos);
        if (pos.indexOf("left") !== -1) {
            $label.css("text-align", "right");
        } else if (pos === "top" || pos === "bottom") {
            $label.css("text-align", "center");
        }
    } else {
        $label.remove();
    }
};

/**
 * Calculates the help svg position, i.e. the positions of the line with arrow and the label text.
 * @param $dom      the dom node to add the help text to
 * @param $label    the label node
 * @param pos       the position of the help text, valid values are: top, topleft (default), topright, bottom, bottomleft, bottomright, left, right
 * @param length    the length of the line (factor)
 * @param offX      the x-offset to the dom node
 * @param offY      the y-offset to the dom node
 * @return {*} an object containing the toX, toY, fromX, fromY, cpX1, cpY1, cpX2, cpY2 and the labelPos. If the element
 *          do not fit in the window an undefined is returned
 */
help.calculatePos = function ($dom, $label, pos, length, offX, offY) {
    let svgPos = {};
    let domOffset = $dom.offset();
    let domWidth = $dom.width();
    let domHeight = $dom.height();
    let labelWidth = $label.width();
    let labelHeight = $label.height();
    let awayX = length * 50;
    let awayY = length * 30;
    let windowWidth = $(window).width();
    let windowHeight = $(window).height();

    if (pos === "top") {
        svgPos.toX = domOffset.left + domWidth / 2 + offX;
        svgPos.toY = domOffset.top - 10 + offY;
        svgPos.fromX = svgPos.toX;
        svgPos.fromY = -1 * awayY + svgPos.toY;
        svgPos.cpX1 = -1;
        svgPos.cpY1 = -1;
        svgPos.cpX2 = -1;
        svgPos.cpY2 = -1;
        svgPos.labelPos = {top: svgPos.fromY - labelHeight - 5, left: svgPos.fromX - labelWidth / 2};
    } else if (pos === "topright") {
        svgPos.toX = domOffset.left + domWidth + 10 + offX;
        svgPos.toY = domOffset.top + domHeight / 2 + offY;
        svgPos.fromX = awayX + svgPos.toX;
        svgPos.fromY = -1 * awayY + svgPos.toY;
        svgPos.cpX1 = svgPos.fromX - awayX / 3;
        svgPos.cpY1 = svgPos.fromY;
        svgPos.cpX2 = svgPos.toX + awayX / 3;
        svgPos.cpY2 = svgPos.toY;
        svgPos.labelPos = {top: svgPos.fromY - labelHeight / 2, left: svgPos.fromX + 5};
    } else if (pos === "bottom") {
        svgPos.toX = domOffset.left + domWidth / 2 + offX;
        svgPos.toY = domOffset.top + domHeight + 10 + offY;
        svgPos.fromX = svgPos.toX;
        svgPos.fromY = awayY + svgPos.toY;
        svgPos.cpX1 = -1;
        svgPos.cpY1 = -1;
        svgPos.cpX2 = -1;
        svgPos.cpY2 = -1;
        svgPos.labelPos = {top: svgPos.fromY + 5, left: svgPos.fromX - labelWidth / 2};
    } else if (pos === "bottomleft") {
        svgPos.toX = domOffset.left - 10 + offX;
        svgPos.toY = domOffset.top + domHeight / 2 + offY;
        svgPos.fromX = -1 * awayX + svgPos.toX;
        svgPos.fromY = awayY + svgPos.toY;
        svgPos.cpX1 = svgPos.fromX + awayX / 3;
        svgPos.cpY1 = svgPos.fromY;
        svgPos.cpX2 = svgPos.toX - awayX / 3;
        svgPos.cpY2 = svgPos.toY;
        svgPos.labelPos = {top: svgPos.fromY - labelHeight / 2, left: svgPos.fromX - labelWidth - 5};
    } else if (pos === "bottomright") {
        svgPos.toX = domOffset.left + domWidth + 10 + offX;
        svgPos.toY = domOffset.top + domHeight / 2 + offY;
        svgPos.fromX = awayX + svgPos.toX;
        svgPos.fromY = awayY + svgPos.toY;
        svgPos.cpX1 = svgPos.fromX - awayX / 3;
        svgPos.cpY1 = svgPos.fromY;
        svgPos.cpX2 = svgPos.toX + awayX / 3;
        svgPos.cpY2 = svgPos.toY;
        svgPos.labelPos = {top: svgPos.fromY - labelHeight / 2, left: svgPos.fromX + 5};
    } else if (pos === "left") {
        svgPos.toX = domOffset.left - 10 + offX;
        svgPos.toY = domOffset.top + domHeight / 2 + offY;
        svgPos.fromX = -1 * awayX + svgPos.toX;
        svgPos.fromY = svgPos.toY;
        svgPos.cpX1 = -1;
        svgPos.cpY1 = -1;
        svgPos.cpX2 = -1;
        svgPos.cpY2 = -1;
        svgPos.labelPos = {top: svgPos.fromY - labelHeight / 2, left: svgPos.fromX - labelWidth - 5};
    } else if (pos === "right") {
        svgPos.toX = domOffset.left + domWidth + 10 + offX;
        svgPos.toY = domOffset.top + domHeight / 2 + offY;
        svgPos.fromX = awayX + svgPos.toX;
        svgPos.fromY = svgPos.toY;
        svgPos.cpX1 = svgPos.fromX - awayX / 3;
        svgPos.cpY1 = svgPos.fromY;
        svgPos.cpX2 = svgPos.toX + awayX / 3;
        svgPos.cpY2 = svgPos.toY;
        svgPos.labelPos = {top: svgPos.fromY - labelHeight / 2, left: svgPos.fromX + 5};
    } // topleft is default
    else {
        svgPos.toX = domOffset.left - 10 + offX;
        svgPos.toY = domOffset.top + domHeight / 2 + offY;
        svgPos.fromX = -1 * awayX + svgPos.toX;
        svgPos.fromY = -1 * awayY + svgPos.toY;
        svgPos.cpX1 = svgPos.fromX + awayX / 3;
        svgPos.cpY1 = svgPos.fromY;
        svgPos.cpX2 = svgPos.toX - awayX / 3;
        svgPos.cpY2 = svgPos.toY;
        svgPos.labelPos = {top: svgPos.fromY - labelHeight / 2, left: svgPos.fromX - labelWidth - 5};
    }

    if (svgPos.labelPos.left < 0 || svgPos.labelPos.top < 50 || svgPos.labelPos.left > (windowWidth - labelWidth - 5) ||
        svgPos.labelPos.top > (windowHeight - labelHeight - 50)) {
        return undefined;
    }
    return svgPos;
};

/**
 * Test if the help group should be shown
 * @param helpGroup     the help group to hide
 * @param cookieName    the cookie name to use
 * @returns {boolean}
 */
help.shouldBeShown = function (helpGroup, cookieName) {
    let windowWidth = $(window).width();
    if (windowWidth < 760) {
        return false;
    }
    $.cookie.json = true;
    let $cookie = $.cookie(cookieName);

    if ($cookie) {
        return ($cookie[COOKIE_SWITCH_OFF] === undefined && $cookie[helpGroup] === undefined);
    }
    return true;
};

/**
 * Set cookie to prevent that the help page is shown again
 * @param helpGroup     the help group to hide
 * @param cookieName    the cookie name to use
 */
help.hideHelpDialog = function (helpGroup, cookieName) {
    $.cookie.json = true;
    let $cookie = $.cookie(cookieName);

    let val = {};
    if ($cookie) {
        val = $cookie;
        val[helpGroup] = true;

    } else {
        val[helpGroup] = true;
    }

    $.cookie(cookieName, val, {expires: 10 * 365, path: '/', secure: ("https:" === document.location.protocol)});
};

/**
 * Set cookie to prevent that the complete help functionality
 * @param cookieName    the cookie name to use
 */
help.hideHelp = function (cookieName) {
    $.cookie.json = true;
    $.cookie(cookieName);

    let val = {};
    val[COOKIE_SWITCH_OFF] = true;

    $.cookie(cookieName, val, {expires: 10 * 365, path: '/', secure: ("https:" === document.location.protocol)});
};


/* ========================================================================
 * init the help layer
 * ========================================================================*/
// eslint-disable-next-line no-unused-vars
function initHelpLayer() {
    let helpGroup = $('body').data('hgroup');
    if (helpGroup) {
        $.ajax({
            type: 'GET',
            url: messages.context_path + '/messages/' + helpGroup,
            dataType: 'json'
        }).fail(function (msg) {
            console.log(msg);
        }).done(function (msg) {
            help.init(helpGroup, 'dc_help', msg.lbl, msg.msg);
        });
    }
}